import { useContext } from "react";
import { QuestionsPageContext } from "../../../context/QuestionsPageContext";
import { useQuery } from "@tanstack/react-query";
import { getColor } from "../../HelpFullFunction";
import { Axios } from "../../../Axios/createAxios";
import { date } from "yup";

export default function Tags() {
  const { selectedTag, setSelectedTag } = useContext(QuestionsPageContext);

  const fetchData = async () => {
    const res = await Axios.get(`/tags`);
    return res.data.tags;
  };
  const { data } = useQuery({
    queryKey: ["tags"],
    queryFn: fetchData,
    staleTime: Infinity,
    onSuccess: (data) => "",
    onError: (e) => console.log(e),
  });

  return (
    <ul value={selectedTag} className={`full-w txt-center tags `}>
      <li
        className={`${selectedTag === null ? "prime-c mixed-bg-c" : ""} text-size-90`}
        value=""
        onClick={() => setSelectedTag(null)}>
        all
      </li>
      {data?.map((item) => (
        <li
          className="text-size-90"
          key={item.id}
          value={item.id}
          onClick={() => {
            setSelectedTag(item.id);
          }}
          style={{ backgroundColor: selectedTag === item.id ? getColor(item.id, 0.3) : "" }}>
          {item.tag}
        </li>
      ))}
    </ul>
  );
}
